import uuidV4 from 'uuid/v4';

function generateLocaleAwareGuideId(params) {
    return Object.values(params).join('-'); // We shouldn't really be relying on the object keys to be in order
}

function getRatingLabel(ratingString) {
    const rating = parseFloat(ratingString, 10);
    return rating;
}

function getPSearchParams(locationData, departDatetime) {
    if (!locationData || !departDatetime) {
        return undefined;
    }

    const types = ['locality', 'political'];

    const batchId = uuidV4();
    const originAddressComps = [{
        long_name: locationData.departure.name,
        short_name: locationData.departure.name,
        types,
    }];
    const originPlaceId = locationData.departure.placeId;
    const originGeometry = {
        location: {
            lat: locationData.departure.latitude,
            lng: locationData.departure.longitude,
        },
    };
    const destinationAddressComps = [{
        long_name: locationData.arrival.name,
        short_name: locationData.arrival.name,
        types,
    }];
    const destinationPlaceId = locationData.arrival.placeId;
    const destinationGeometry = {
        location: {
            lat: locationData.arrival.latitude,
            lng: locationData.arrival.longitude,
        },
    };

    return {
        batchId,
        departDatetime,
        destinationAddressComps,
        destinationGeometry,
        destinationPlaceId,
        direction: 'depart',
        originAddressComps,
        originGeometry,
        originPlaceId,
    };
}

const hasTranslation = (t, str) => t(str) !== str;

const isTranslated = (t, arr = []) => arr.every((key) => hasTranslation(t, key));

export {
    generateLocaleAwareGuideId,
    getPSearchParams,
    getRatingLabel,
    hasTranslation,
    isTranslated,
};
